import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { AssetsApi } from '../../../api/assets';
import { ApiReq, emptyValue } from '../../../api';
import { DownloadTokenResponse } from '../../../types';

export class FileTokenService {
  readonly assetsApi = new AssetsApi();

  @observable fileToken?: string;

  @observable.ref downloadTokenReq: ApiReq<DownloadTokenResponse> = emptyValue;

  constructor() {
    makeObservable(this);
  }

  @computed get reqFileToken() {
    if (
      this.downloadTokenReq.state !== 'fulfilled' ||
      !this.downloadTokenReq.value
    ) {
      return '';
    }
    return this.downloadTokenReq.value.data?.token;
  }

  @computed get isTokenLoading() {
    return this.downloadTokenReq.state === 'pending';
  }

  @action setFileToken = (token: string) => {
      this.fileToken = token;
  }

  @action getFileDownloadToken = async (
    assetId: number,
    attachmentId: number,
  ) => {
    this.downloadTokenReq = this.assetsApi.getDownloadAttachmentToken(
      attachmentId,
      assetId,
    );
    await this.downloadTokenReq;

    runInAction(() => {
      if (this.reqFileToken) {
        this.fileToken = this.reqFileToken;
      }
    })

    return this.downloadTokenReq;
  };



  @action resetToken = () => {
    this.downloadTokenReq = emptyValue;
  };
}
